<template>
  <div
    class="plan-badge"
    :class="[colorClass]"
    :title="planLabel"
  >
    <q-icon v-if="icon" :name="icon" size="14px"  />
    <span>{{ planLabel }}</span>
  </div>
</template>

<script setup>
import { computed, onMounted } from 'vue'
import { usePlansStore } from '@/stores/plansStore'


const props = defineProps({
  plan: {
    type: String,
    default: 'free',
  },
  icon: {
    type: String,
    default: '',
  },
  showShortName: {
    type: Boolean,
    default: true,
  },
})

const plansStore = usePlansStore()
onMounted(() => { if (!plansStore.plans?.length) plansStore.fetchPlans() })
const planIndex = computed(() => Object.fromEntries((plansStore.plans || []).map(p => [p.id, p])))
const planInfo = computed(() => planIndex.value[props.plan] || { name: 'Free', shortName: 'FR', color: 'grey-5' })
const planLabel = computed(() => props.showShortName ? (planInfo.value.shortName || planInfo.value.name) : planInfo.value.name)
const colorClass = computed(() => `plan-badge--${props.plan}`)
</script>

<style scoped>
.plan-badge {
  display: inline-flex;
  align-items: center;
  font-size: 0.52rem;
  font-weight: 500;
  border-radius: 5px;
  padding: 0.5px 4px 0.5px 3px;
  background: rgba(0,0,0,0.08);
  color: #444;
  position: absolute;
  left: 0;
  bottom: 0;
  margin: 2px;
  z-index: 2;
  box-shadow: 0 1px 2px rgba(0,0,0,0.04);
  pointer-events: none;
  min-width: 18px;
  min-height: 13px;
  line-height: 1.1;
}
.plan-badge--free {
  background: #e0e0e0;
  color: #666;
}
.plan-badge--premium {
  background: #ffe082;
  color: #795548;
}
.plan-badge--pro {
  background: #b3e5fc;
  color: #0277bd;
}
.plan-badge--custom {
  background: #c8e6c9;
  color: #388e3c;
}
</style>
